
import { runInAction, makeAutoObservable } from "mobx"

import { BaseStore } from "stores/base_store"
import DeviceAPI from "api/device_api";

export type DeviceProps = {
    key: string;
    name: string;
    user_agent: string;
    sub: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: DeviceProps) => void;
};

// Domain object Device
export class Device implements DeviceProps {
    key = "";
    name = "";
    user_agent = "";
    sub = "";
    date_created = "";
    date_updated = "";

    constructor(attributes: DeviceProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: DeviceProps) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class DeviceStore extends BaseStore<DeviceProps, Device> {

    async fetchList(identityKey: string, cursor = "") {
        // Autogenerated
        return DeviceAPI.list(identityKey, cursor).then((resp) => {
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchList(identityKey, resp.cursor);
            }
            return resp.items;
        })
    }

    async fetchDevice(key: string) {
        return DeviceAPI.load(key).then((data: DeviceProps) => {
            this.receiveUpdate(data);
            return data;
        });
    }

    async updateSub(identityKey: string, deviceKey: string, sub: PushSubscriptionJSON) {
        console.log("2024-04-05 updateSub: %o", sub);
        return DeviceAPI.updateSub(identityKey, deviceKey, sub).then((data: DeviceProps) => {
            this.receiveUpdate(data);
            return data;
        });
    }

    async create(identityKey: string, name: string) {
        return DeviceAPI.create(identityKey, name).then((data: DeviceProps) => {
            this.receiveUpdate(data);
            return data;
        });
    }

    modelConstructor() {
        return Device;
    }

}
